document.querySelectorAll('.pattern-contact-info-map').forEach(block => {
    const canvas  = block.querySelector('.cimap-map-canvas');
    const offices = block.querySelectorAll('.cimap-office');

    if (!canvas || !offices.length) return;

    const zoom = parseInt(canvas.dataset.zoom, 10) || 14;

    const mapStyles = [
        { featureType: 'all', elementType: 'labels.text.fill', stylers: [{ saturation: 36 }, { color: '#333333' }, { lightness: 40 }] },
        { featureType: 'all', elementType: 'labels.text.stroke', stylers: [{ visibility: 'on' }, { color: '#ffffff' }, { lightness: 16 }] },
        { featureType: 'all', elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
        { featureType: 'landscape', elementType: 'geometry', stylers: [{ color: '#f3f7f7' }, { lightness: 20 }] },
        { featureType: 'poi', elementType: 'geometry', stylers: [{ visibility: 'off' }] },
        { featureType: 'road.highway', elementType: 'geometry.fill', stylers: [{ color: '#ffffff' }, { lightness: 17 }] },
        { featureType: 'road.highway', elementType: 'geometry.stroke', stylers: [{ weight: '0.01' }] },
        { featureType: 'road.arterial', elementType: 'geometry', stylers: [{ lightness: 18 }] },
        { featureType: 'road.local', elementType: 'geometry', stylers: [{ lightness: 16 }, { color: '#ffffff' }, { visibility: 'simplified' }] },
        { featureType: 'transit', elementType: 'geometry', stylers: [{ visibility: 'off' }] },
        { featureType: 'water', elementType: 'geometry', stylers: [{ color: '#ebf1f1' }] },
    ];

    function initMap() {
        const markerEls = canvas.querySelectorAll('.marker');
        if (!markerEls.length) return;

        const firstLat = parseFloat(markerEls[0].dataset.lat);
        const firstLng = parseFloat(markerEls[0].dataset.lng);

        const map = new google.maps.Map(canvas, {
            center: { lat: firstLat, lng: firstLng },
            zoom,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            styles: mapStyles,
        });

        // Store markers indexed by office index
        const markers = {};
        markerEls.forEach(el => {
            const lat = parseFloat(el.dataset.lat);
            const lng = parseFloat(el.dataset.lng);
            const idx = el.dataset.index;

            markers[idx] = new google.maps.Marker({
                position: { lat, lng },
                map,
            });
        });

        // Office click — pan map and update active state
        offices.forEach(office => {
            office.addEventListener('click', () => {
                offices.forEach(o => {
                    o.classList.remove('is-active');
                    o.setAttribute('aria-pressed', 'false');
                });
                office.classList.add('is-active');
                office.setAttribute('aria-pressed', 'true');

                const lat = parseFloat(office.dataset.lat);
                const lng = parseFloat(office.dataset.lng);
                if (!isNaN(lat) && !isNaN(lng)) {
                    map.panTo({ lat, lng });
                    map.setZoom(zoom);
                }
            });

            office.addEventListener('keydown', e => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    office.click();
                }
            });
        });
    }

    if (typeof google !== 'undefined' && google.maps) {
        initMap();
    } else {
        window.addEventListener('load', initMap);
    }
});
